import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import Loader from "../components/common/Loader";
import TreeComponent from "../components/widgets/TreeComponent";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import classnames from "classnames";
import moment from "moment";
import "moment/locale/it";
import { IUserMeeting } from "../app/models/meeting";
import { translationHookOptions } from "../app/localization/localization";
import { useTranslation } from "react-i18next";

interface IParams {
  meetingId: string;
}

const OfflineMeetingsTreePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {
    getMeeting,
    loadNodesFromDb,
    treeNodes,
    resetNodeTree,
    currentTenant,
  } = rootStore.offlineStore;
  const [treeLoaded, setTreeLoaded] = useState(false);
  const [meeting, setMeeting] = useState<IUserMeeting | null>(null);
  const [t] = useTranslation(["translation"], translationHookOptions);
  const {isMobileMediaQuery} = rootStore.responsiveStore;
  const getStringMeetingDate = (meeting: IUserMeeting | null) => {
    let stringDate = "";
    if (meeting) {
      let momentStart = moment(meeting.startDate);
      stringDate = t("meeting_page_date", {
        val: momentStart.toDate(),
        formatParams: {
          val: {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
          },
        },
      });
    }
    return stringDate;
  };

  useEffect(() => {
    let intMeetingId = parseInt(match.params.meetingId);
    if (intMeetingId) {
      let meet = getMeeting(intMeetingId);
      if (meet) setMeeting(meet);
      else history.push("../meetings");

      loadNodesFromDb(intMeetingId)
        .then((res) => {
          setTreeLoaded(true);
          const scrollableElement = document.querySelector(".odgPage");
          if (scrollableElement) disableBodyScroll(scrollableElement);
        })
        .catch();
    } else history.push("../meetings");

    return () => {
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
      resetNodeTree();
    };
  }, [
    loadNodesFromDb,
    history,
    match.params.meetingId,
    resetNodeTree,
    getMeeting,
  ]);

  if (!treeLoaded || !meeting) return <Loader />;

  return (
    <div className="odgPage">
      <Row>
        <div className={classnames(isMobileMediaQuery ? "odgTitoloMobile" :
            "odgTitolo"," text-white bg-dark")}>
          {meeting ? meeting.title : t("meeting_page_generic_title")}
        </div>
      </Row>
      <Row>
        <div className={classnames(isMobileMediaQuery ? "odgSottoTitoloMobile" :
            "odgSottoTitolo")}>{getStringMeetingDate(meeting)}</div>
      </Row>
      <Row>
        <Col xs={12} className="odgContainer">
          {treeNodes && (
            <TreeComponent
              tenant={currentTenant!}
              nodes={treeNodes}
              type="meetings"
              sourceId={meeting.id}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default observer(OfflineMeetingsTreePage);
